import { FiGrid, FiSmartphone, FiBell, FiUser, FiDollarSign, FiAlertTriangle, FiTrendingUp, FiSettings, FiMenu } from 'react-icons/fi';
import { FiLifeBuoy } from 'react-icons/fi';

const DashboardHeader = ({ activeTab, sidebarOpen, setSidebarOpen, isMobile, actionElement }) => {

  const getTabInfo = () => {
    switch (activeTab) {
      case 'overview': return { title: 'Dashboard', description: 'Tenha uma visão geral de todos os seus dados e métricas.', Icon: FiGrid };
      case 'apps': return { title: 'Meus Apps', description: 'Crie e gerencie todos os seus aplicativos.', Icon: FiSmartphone };
      case 'notifications': return { title: 'Notificações', description: 'Acompanhe as novidades e avisos do sistema.', Icon: FiBell };
      case 'profile': return { title: 'Meu Perfil', description: 'Gerencie suas informações pessoais e senha.', Icon: FiUser };
      case 'financial': return { title: 'Financeiro', description: 'Acompanhe faturas e pagamentos.', Icon: FiDollarSign };
      case 'alerts': return { title: 'Alertas', description: 'Visualize os alertas de segurança e sistema.', Icon: FiAlertTriangle };
      case 'analytics': return { title: 'Analytics', description: 'Acompanhe métricas detalhadas dos seus apps.', Icon: FiTrendingUp };
      case 'settings': return { title: 'Configurações', description: 'Configure as preferências da sua conta.', Icon: FiSettings };
      case 'support': return { title: 'Suporte', description: 'Central de ajuda e suporte técnico.', Icon: FiLifeBuoy };
      default: return { title: 'Dashboard', description: 'Bem-vindo ao painel de controle.', Icon: FiGrid };
    }
  };

  const tabInfo = getTabInfo();

  return (
    <div className="flex items-center justify-between mb-6 sm:mb-8 gap-4">
      {/* Botão Hamburger - só aparece no mobile */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(true)}
          className="flex-shrink-0 p-2 rounded-none text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white transition-colors"
          aria-label="Abrir menu"
        >
          <FiMenu className="w-5 h-5" />
        </button>
      )}

      <div className="flex-1 min-w-0">
        <h2 className="text-xl sm:text-2xl lg:text-[28px] font-extrabold text-gray-900 dark:text-white tracking-tight leading-tight truncate">
          {tabInfo.title}
        </h2>
        <p className="text-gray-500 dark:text-gray-400 text-sm sm:text-[15px] mt-0.5 truncate">
          {tabInfo.description || 'Gerencie todas as informações e configurações.'}
        </p>
      </div>
      
      {actionElement && (
        <div className="flex-shrink-0">
          {actionElement}
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
